import React from "react";

interface User {
  id: string;
  name: string;
  first_seen_at: string;
  last_seen_at: string;
  meme_count: number;
}

interface UsersGridProps {
  users: User[];
}

const UsersGrid: React.FC<UsersGridProps> = ({ users }) => {
  if (users.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg" dir="rtl">
          אין משתמשים עדיין
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-2" dir="rtl">
          רשימת משתמשים
        </h2>
        <p className="text-gray-600" dir="rtl">
          סה"כ {users.length} משתמשים רשומים
        </p>
      </div>

      <div className="overflow-x-auto">
        <table
          className="w-full bg-white/50 backdrop-blur-sm rounded-xl shadow-lg border border-pink-100"
          dir="rtl"
        >
          <thead className="bg-pink-50">
            <tr>
              <th className="px-6 py-4 text-right font-bold text-gray-800 border-b border-pink-200">
                שם המשתמש
              </th>
              <th className="px-6 py-4 text-center font-bold text-gray-800 border-b border-pink-200">
                מימז נשלחו
              </th>
              <th className="px-6 py-4 text-center font-bold text-gray-800 border-b border-pink-200">
                נרשם לראשונה
              </th>
              <th className="px-6 py-4 text-center font-bold text-gray-800 border-b border-pink-200">
                נראה לאחרונה
              </th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <tr
                key={user.id}
                className={`hover:bg-pink-25 transition-colors ${
                  index % 2 === 0 ? "bg-white/30" : "bg-white/20"
                }`}
              >
                <td className="px-6 py-4 text-right font-semibold text-gray-800 border-b border-pink-100">
                  {user.name}
                </td>
                <td className="px-6 py-4 text-center border-b border-pink-100">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-pink-100 text-pink-800">
                    {user.meme_count}
                  </span>
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-600 border-b border-pink-100">
                  {new Date(user.first_seen_at).toLocaleDateString("he-IL")}
                </td>
                <td className="px-6 py-4 text-center text-sm text-gray-600 border-b border-pink-100">
                  {new Date(user.last_seen_at).toLocaleDateString("he-IL")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersGrid;
